/**
 * Additional paid users = billable users above the org's free user quota
 * (pricing tier, override wins). Returns `undefined` when the quota is unknown,
 * so the UI can show "—" instead of billing every user against a quota of 0.
 */
export const computeAdditionalPaidUsers = (
  billableUsers: number,
  freeUserQuota?: number | null
): number | undefined => {
  if (freeUserQuota === null || freeUserQuota === undefined) return undefined

  return Math.max(0, billableUsers - Math.max(0, freeUserQuota))
}
